import { Helmet } from "react-helmet-async";
import { useLang } from "@/lib/i18n";

const SITE = "https://mevaluxproperty.com";

export const Seo = ({ title, description, image = "/img/hero.jpg", path = "", jsonLd }) => {
  const { lang, t } = useLang();
  const full = title ? `${title} | MEVALUX PROPERTY` : `MEVALUX PROPERTY – ${t.slogan}`;
  const desc = description || t.lifestyleText;
  const img = image.startsWith("http") ? image : `${SITE}${image}`;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{full}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={`${SITE}${path}`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="MEVALUX PROPERTY" />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={`${SITE}${path}`} />
      <meta property="og:locale" content={lang === "sk" ? "sk_SK" : "en_GB"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
